import { Components, Theme } from "@mui/material";

export const MuiMenuItem: Components<Theme>["MuiMenuItem"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 8,
      margin: "2px 0",
      padding: "8px 12px",
      transition: theme.transitions.create(["background-color"], {
        duration: theme.transitions.duration.shortest,
      }),
    }),
    selected: ({ theme }) => ({
      backgroundColor: `${theme.palette.primary.main}12 !important`,
      color: theme.palette.primary.main,
      fontWeight: 600,
    }),
  },
};

export const MuiMenu: Components<Theme>["MuiMenu"] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: 14,
      boxShadow:
        theme.palette.mode === "dark"
          ? "0 8px 32px rgba(0,0,0,0.4)"
          : "0 8px 32px rgba(0,0,0,0.08)",
      border: `1px solid ${theme.palette.divider}`,
    }),
    list: {
      padding: 6,
    },
  },
};
